import React, { useState, useEffect, useRef } from 'react';
import './HouseKeepingList.scss';
import {
  TextField,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  Menu,
  MenuItem,
  InputAdornment,
  Checkbox,
} from '@material-ui/core';
import CreateIcon from '@mui/icons-material/Create';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import SearchIcon from '@material-ui/icons/Search';
import { AddCircle, DragIndicator, MoreHoriz } from '@material-ui/icons';
import {
  HOUSEKEEPING_VIEW,
  HOUSEKEEPING_EDIT,
  HOUSEKEEPING_CREATE,
} from '../../../../../constants/ServiceConstants';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_SERVICE_REQUEST,
} from '../../../../../constants/RoleConsts';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import { allHouseKeeping, fetchAllServiceReqeust, setHouseKeeping } from '../../../servicesSlice';
import { useSelector } from 'react-redux';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import {
  deleteHousekeeing,
  houseKeepingActivate,
  houseKeepingDeactivate,
  deleteSelectedItems,
  updateSelectedItemsStatus,
} from '../../../../../utils/ServicesAPIUtils';
import { useDispatch } from 'react-redux';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import CustomChip from '../../../../../shared/form-controls/custom-chip/Custom-Chip';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import useOutsideAlerter from '../../../../../custom-hooks/useOutsideAlerter';
import SearchBar from '../../../../../shared/search-bar/Search-Bar';
import { SaveButton } from '../../../../../shared/custom-dragdrop/Save-Button';
import { handleOnDragEnd } from '../../../../../shared/custom-dragdrop/dragDrop';
import { createDataSortMapping } from '../../../../../utils/PropertyAPIUtils';
import MultipleDeleteConfirmationPopup from '../../../../../shared/MultiActionPopUp/MultiDeleteConfirmationPopup';
import ActionMenuList from '../../../../../shared/ActionMenuList/ActionMenuList';
import {
  PARTIAL_CHECKBOX_GREEN,
  ResetFilterList,
  getCheckedIds,
  updateCheckedStatus,
  updateSelectedModule,
} from '../../../../../utils/formUtils';
import { generateConfirmationMessage } from '../../../../../utils/formUtils';
import BulkActionCheckBox from '../../../../../shared/MultiActionPopUp/BulkActionCheckBox';
import MultipleSelectionAlert from '../../../../../shared/MultiActionPopUp/MultipleSelectionAlert';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const HouseKeepingList = (props) => {
  const [houseKeepingList, setHouseKeepingList] = useState([]);
  const [loading, setLoading] = useState(false);
  const {
    onDrawerToggle,
    onViewToggle,
    selectedHotel,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
  } = props;
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
  });
  const originalHouseKeepings = useSelector(allHouseKeeping);
  const allHouseKeepings = useSelector(allHouseKeeping);
  const [visible, setVisible] = useState(false);
  const wrapperRef = useRef(null);
  const searchRef = useRef(null);
  const prevHotelIdRef = useRef(selectedHotel);
  const [popUp, setPopUp] = useState(false);
  const [searchText, setSearchText] = useState('');
  const dragCellWidthsRef = useRef([]);
  const dragDisabled = !!searchText || houseKeepingList?.length <= 1;
  const [searchButton, setSearchButton] = useState(true);
  const [actionMenuAnchorEl, setActionMenuAnchorEl] = useState(null);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [actionMenuList, setActionMenuList] = useState([]);
  const [actionName, setActionName] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [showMultipleDeleteConfirmation, setShowMultipleDeleteConfirmation] = useState(false);
  const [showBulkActiveDeactiveConfirmation, setShowBulkActiveDeactiveConfirmation] =
    useState(false);
  const [showBulkSearchAlert, setShowBulkSearchAlert] = useState(false);
  const [showBulkKebabSelectionAlert, setShowBulkKebabSelectionAlert] = useState(false);

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };
  const dispatch = useDispatch();
  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      group: null,
    });
  };

  const onOpenDrawer = (event, type) => {
    if (selectedHKLength) {
      setHouseKeepingList(ResetFilterList);
    }
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.group);
    handleClose();
  };

  const onViewDetails = (category, e) => {
    if (e?.target?.tagName === 'TD') {
      onViewToggle(HOUSEKEEPING_VIEW, true, category);
    }
  };

  const onViewDetailsIcon = (e) => {
    if (
      e.target.className ===
      'MuiButtonBase-root MuiListItem-root MuiMenuItem-root pe-4 MuiMenuItem-gutters MuiListItem-gutters MuiListItem-button'
    ) {
      onViewToggle(HOUSEKEEPING_VIEW, true, selectedValue.group);
    }
  };

  const handleCellMenuClick = (event, item) => {
    if (selectedHKLength > 1) {
      setShowBulkKebabSelectionAlert(true);
    } else {
      setSelectedValue({
        id: item.id,
        name: item.name,
        title: '',
        description: '',
        status: false,
        isActive: item.isActive,
        anchorEl: event.currentTarget,
        group: item,
      });
    }
  };

  useEffect(() => {
    setHouseKeepingList(
      allHouseKeepings?.map((houseKeeping) => {
        return {
          ...houseKeeping,
          isChecked: false,
        };
      }),
    );
    setLoading(false);
    setSearchText('');
    setSearchButton(true);
  }, [allHouseKeepings]);

  const handleSearchText = async (searchText) => {
    setSearchText(searchText);
    const checkedIdList = getCheckedIds(houseKeepingList, 'isChecked');
    const filteredRows = await originalHouseKeepings.filter((item) => {
      return item.name.toLowerCase().includes(searchText.toLowerCase());
    });
    onsetPage(0);
    const updatedCheckedList = updateCheckedStatus(filteredRows, checkedIdList);
    setHouseKeepingList(updatedCheckedList);
  };

  useEffect(() => {
    updateSelectedModule(houseKeepingList, setActionMenuList, setIsAllSelected);
  }, [houseKeepingList]);

  useEffect(() => {
    if (loading || houseKeepingList?.length === 0) return;
    const totalItems = houseKeepingList?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [houseKeepingList?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== selectedHotel) {
      onsetPage(0);
    }
    prevHotelIdRef.current = selectedHotel;
  }, [selectedHotel]);

  const handleDeletePopupOpen = () => {
    handleClose();
    let currVal = { ...selectedValue };
    currVal['title'] = 'Are you sure you want to delete';
    currVal['description'] = 'This action cannot be reversed.';
    currVal.status = true;
    currVal.anchorEl = null;
    setSelectedValue(currVal);
  };

  const getCheckedHKList = houseKeepingList?.filter((HK) => HK?.isChecked);
  const listOfHouseKeepingIds = getCheckedHKList?.map((HK) => HK?.id);
  const selectedHKLength = getCheckedHKList?.length;

  const deleteService = async () => {
    handleClose();
    try {
      dispatch(stepUpLoaderCount());
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      await deleteHousekeeing(selectedValue.id, selectedHotel, language);
      dispatch(fetchAllServiceReqeust(selectedHotel));
      notificationManager('success', 'HouseKeeping deleted successfully');
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Failed to delete HouseKeeping',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onDeleteCancel = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
    });
  };

  const handleActivate = async () => {
    handleClose();
    const selectedLanguage = decryptLocalStorage('lang');
    const language = selectedLanguage !== 'en' ? selectedLanguage : '';
    if (selectedValue.isActive) {
      try {
        dispatch(stepUpLoaderCount());
        await houseKeepingDeactivate(selectedValue.id, selectedHotel, language);
        dispatch(fetchAllServiceReqeust(selectedHotel));
        notificationManager('success', 'HouseKeeping deactivated successfully');
        setSelectedValue({
          id: '',
          name: '',
          title: '',
          description: '',
          status: false,
          brand: null,
        });
      } catch (e) {
        notificationManager(
          'danger',
          e.graphQLErrors ? e.graphQLErrors[0].message : 'HouseKeeping deactivated failed',
        );
      } finally {
        dispatch(stepDownLoaderCount());
      }
    } else {
      try {
        dispatch(stepUpLoaderCount());
        await houseKeepingActivate(selectedValue.id, selectedHotel, language);
        dispatch(fetchAllServiceReqeust(selectedHotel));
        notificationManager('success', 'HouseKeeping activated successfully');
        setSelectedValue({
          id: '',
          name: '',
          title: '',
          description: '',
          status: false,
          brand: null,
        });
      } catch (e) {
        notificationManager(
          'danger',
          e.graphQLErrors ? e.graphQLErrors[0].message : 'HouseKeeping activated failed',
        );
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const handleActionMenuOpen = (event) => {
    setActionMenuAnchorEl(event.currentTarget);
  };

  const handleActionMenuClose = () => {
    setActionMenuAnchorEl(null);
  };

  const handleAction = (actionName) => {
    let selectedDiscount = houseKeepingList?.filter((item) => item?.isChecked);
    switch (actionName) {
      case 'Delete':
        if (selectedDiscount?.length > 0) {
          setShowMultipleDeleteConfirmation(true);
          setActionName('delete');
        }
        break;
      case 'Activate':
        if (selectedDiscount?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('activate');
          setIsActive(true);
        }
        break;
      case 'Deactivate':
        if (selectedDiscount?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('deactivate');
          setIsActive(false);
        }
        break;
      default:
        break;
    }
  };

  const handleCheckboxChange = (id) => {
    let actionListName = [];
    let index = houseKeepingList?.findIndex((item) => item.id === id);
    if (!houseKeepingList[index]?.isChecked) {
      houseKeepingList[index] = { ...houseKeepingList[index], isChecked: true };
    } else {
      houseKeepingList[index].isChecked = !houseKeepingList[index]?.isChecked;
    }
    setHouseKeepingList([...houseKeepingList]);

    let actionList = houseKeepingList
      ?.filter((sInfo) => sInfo?.isChecked)
      .map((status) => status?.isActive);

    const checkedItems = houseKeepingList?.filter((combosList) => combosList?.isChecked);

    if (checkedItems.length === 0) {
      setActionMenuList([]);
      setIsAllSelected(false);
      return;
    }

    const isActiveSelected = actionList.includes(true);
    const isInactiveSelected = actionList.includes(false);

    if (isActiveSelected && isInactiveSelected) {
      actionListName.push('Activate', 'Deactivate');
    } else if (isActiveSelected) {
      actionListName.push('Deactivate');
    } else if (isInactiveSelected) {
      actionListName.push('Activate');
    }

    const isAllSelected = houseKeepingList?.every((item) => item?.isChecked);
    setIsAllSelected(isAllSelected);
    if (!houseKeepingList[index].isChecked && !actionList?.some((item) => item?.isChecked)) {
      setActionMenuList([]);
    }
    setActionMenuList(actionListName);
  };

  const handleSelectAll = (event) => {
    let selectedMenuList = [];
    let actionListName = [];
    const CheckedValue = event?.target?.checked;
    setIsAllSelected(CheckedValue);
    selectedMenuList = houseKeepingList?.map((item) => {
      return {
        ...item,
        isChecked: CheckedValue,
      };
    });

    const isActive = selectedMenuList?.some((Rate_filter) => Rate_filter?.isActive);
    const isInactive = selectedMenuList?.some((Rate_filter) => !Rate_filter.isActive);

    if (isActive && !actionListName?.includes('Deactivate')) {
      actionListName.push('Deactivate');
    }
    if (isInactive && !actionListName?.includes('Activate')) {
      actionListName.push('Activate');
    }

    setHouseKeepingList([...selectedMenuList]);

    const sortActionMenuList = actionListName.sort((a, b) => {
      const order = { Activate: 1, Deactivate: 2, Delete: 3 };
      return order[a] - order[b];
    });

    setActionMenuList(sortActionMenuList);

    if (!event?.target?.checked && !selectedMenuList?.some((item) => item?.isChecked)) {
      setActionMenuList([]);
    }
  };

  const onApiCallConfirmationNotification = generateConfirmationMessage(
    'Housekeeping Service',
    listOfHouseKeepingIds?.length,
    isActive,
  );

  const handleMultipleStatusChange = async () => {
    handleClose();
    setActionMenuList([]);
    try {
      dispatch(stepUpLoaderCount());
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'HOUSE_KEEPING';
      await updateSelectedItemsStatus(
        listOfHouseKeepingIds,
        selectedHotel,
        selectedLang,
        moduleName,
        '',
        isActive,
        searchText.length > 0 ? false : isAllSelected,
      );
      dispatch(fetchAllServiceReqeust(selectedHotel));
      notificationManager('success', onApiCallConfirmationNotification);
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        activate: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'The status of Housekeeping was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }

    setIsAllSelected(false);
    setHouseKeepingList(ResetFilterList);
  };

  const deleteMultipleSelection = async () => {
    handleClose();
    try {
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'HOUSE_KEEPING';
      await deleteSelectedItems(
        listOfHouseKeepingIds,
        selectedHotel,
        selectedLang,
        moduleName,
        '',
        searchText.length > 0 ? false : isAllSelected,
      );
      dispatch(fetchAllServiceReqeust(selectedHotel));
      notificationManager('success', 'HouseKeeping deleted successfully');
      setSelectedValue({
        ...selectedValue,
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Failed to delete HouseKeeping',
      );
    }
    setIsAllSelected(false);
    setActionMenuList([]);
    setHouseKeepingList(ResetFilterList);
  };

  const handleContinue = () => {
    setShowBulkSearchAlert(false);
    setSearchText('');
    setHouseKeepingList(
      originalHouseKeepings?.map((house) => ({
        ...house,
        isChecked: false,
      })),
    );
    setTimeout(() => {
      searchRef?.current?.focus();
    }, 0);
  };

  const handleSearchInputFocus = (e) => {
    if (selectedHKLength) {
      searchRef?.current?.blur();
      setShowBulkSearchAlert(true);
    } else {
      setShowBulkSearchAlert(false);
    }
  };

  return (
    <div>
      {selectedValue.id && selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={deleteService}
          onDeleteCancel={onDeleteCancel}
        />
      )}

      <div className='row m-2 d-flex mt-4'>
        <div
          className='col-md-4'
          onClick={() => {
            visible && setPopUp(true);
          }}
        >
          <TextField
            className='w-100'
            onChange={(e) => {
              handleSearchText(e.target.value);
              setSearchButton(e?.target?.value ? false : true);
            }}
            onFocus={(e) => handleSearchInputFocus(e)}
            label='Search'
            inputRef={searchRef}
            value={searchText}
            InputProps={
              searchButton && {
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton className='showpopup'>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }
            }
          />
        </div>
        <div className='col-12 col-lg-8 pt-3 pt-lg-0 d-flex justify-content-end gap-2'>
          {actionMenuList?.length !== 0 && (
            <div>
              <Button
                onClick={handleActionMenuOpen}
                variant='outlined'
                size='large'
                className='showpopup'
                endIcon={<ArrowDropDownIcon />}
              >
                Actions
              </Button>
              <ActionMenuList
                anchorEl={actionMenuAnchorEl ?? null}
                handleClose={handleActionMenuClose}
                handleAction={handleAction}
                actionMenuItems={actionMenuList}
              />
            </div>
          )}
          <SaveButton
            visible={visible}
            setVisible={setVisible}
            popUp={popUp}
            setPopUp={setPopUp}
            placeHolder={houseKeepingList}
            setPlaceHolder={setHouseKeepingList}
            globalPlaceHolder={originalHouseKeepings}
            setGlobalPlaceHolder={setHouseKeeping}
            dispatch={dispatch}
            mappingApi={createDataSortMapping}
            displayText='Housekeeping'
            module='HOUSE_KEEPING'
          />
          {permissions[RBAC_TYPE_SERVICES_SERVICE_REQUEST] ===
            RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
            <Button
              variant='contained'
              color='primary'
              size='large'
              startIcon={<AddCircle />}
              onClick={(e) => {
                onOpenDrawer(e, HOUSEKEEPING_CREATE);
              }}
              className='showpopup'
            >
              Add Service
            </Button>
          )}
        </div>
      </div>

      <div ref={wrapperRef} className='row mx-2 d-flex mt-3'>
        {loading ? (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        ) : (
          houseKeepingList && (
            <TableContainer className='housekeeping-list-table'>
              <Table className='list-table' aria-label='simple table'>
                <TableHead>
                  <TableRow className='border-white pointer'>
                    <TableCell className={`w-5 ${dragDisabled ? '' : 'ps-5'}`}>
                      <BulkActionCheckBox
                        onChange={handleSelectAll}
                        checked={isAllSelected || false}
                        selectedLength={selectedHKLength}
                        totalLength={allHouseKeepings?.length}
                        inputProps={{
                          'aria-label': 'select all HouseKeeping',
                        }}
                        className={PARTIAL_CHECKBOX_GREEN}
                      />
                    </TableCell>
                    <TableCell className='w-30'>Name</TableCell>
                    <TableCell className='w-20' align='right'>
                      No.of Items
                    </TableCell>
                    <TableCell className='w-20' align='right'>
                      Max Quantity
                    </TableCell>
                    <TableCell className='w-20' align='center'>
                      Status
                    </TableCell>
                    <TableCell align='right'></TableCell>
                  </TableRow>
                </TableHead>

                <DragDropContext
                  onBeforeDragStart={(start) => {
                    const rows = document.querySelectorAll('.housekeeping-list-table tbody tr');
                    const row = rows[start.source.index];
                    if (row) {
                      const cells = row.querySelectorAll('td');
                      dragCellWidthsRef.current = Array.from(cells).map(
                        (cell) => cell.getBoundingClientRect().width,
                      );
                    }
                  }}
                  onDragEnd={(event) =>
                    handleOnDragEnd(
                      event,
                      setVisible,
                      houseKeepingList,
                      setHouseKeepingList,
                      false,
                      page,
                      rowsPerPage,
                    )
                  }
                  isDropDisabled={dragDisabled}
                >
                  <Droppable droppableId='spas' isDropDisabled={dragDisabled}>
                    {(provided) => (
                      <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                        {(rowsPerPage > 0
                          ? houseKeepingList.slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage,
                            )
                          : houseKeepingList
                        ).map((item, i) => (
                          <Draggable
                            key={item.id}
                            draggableId={item.id}
                            index={i}
                            isDragDisabled={dragDisabled}
                          >
                            {(provided, snapshot) => (
                              <TableRow
                                key={i}
                                className='border-white pointer'
                                onClick={(e) => {
                                  onViewDetails(item, e);
                                }}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={{
                                  ...provided.draggableProps.style,
                                  ...(snapshot.isDragging && { display: 'table' }),
                                }}
                              >
                                <TableCell className='w-12' style={snapshot.isDragging ? { width: dragCellWidthsRef.current[0] } : {}}>
                                  <div style={{ display: 'flex', alignItems: 'center' }}>
                                    {!dragDisabled && (
                                      <span style={{ marginRight: 3 }}>
                                        <DragIndicator className='res-menu-accordion-drag' />
                                      </span>
                                    )}
                                    <Checkbox
                                      onChange={(event) => handleCheckboxChange(item?.id)}
                                      checked={item?.isChecked || false}
                                      inputProps={{
                                        'aria-label': `select houseKeepingList ${item?.id}`,
                                      }}
                                    />
                                  </div>
                                </TableCell>
                                <TableCell className='w-30' style={snapshot.isDragging ? { width: dragCellWidthsRef.current[1] } : {}}>{item?.name}</TableCell>
                                <TableCell className='w-20' align='right' style={snapshot.isDragging ? { width: dragCellWidthsRef.current[2] } : {}}>
                                  {item?.isItemActive ? item?.items?.length : 'NA'}
                                </TableCell>
                                <TableCell className='w-20' align='right' style={snapshot.isDragging ? { width: dragCellWidthsRef.current[3] } : {}}>
                                  {item?.maxQuantityActive ? item?.maxQuantity : 'NA'}
                                </TableCell>
                                <TableCell className='w-20' align='center' style={snapshot.isDragging ? { width: dragCellWidthsRef.current[4] } : {}}>
                                  <CustomChip
                                    label={item?.isActive ? 'Active' : 'Inactive'}
                                    color={item?.isActive ? 'primary' : 'default'}
                                  />
                                </TableCell>
                                <TableCell className='kebab-menu' align='right' style={snapshot.isDragging ? { width: dragCellWidthsRef.current[5] } : {}}>
                                  {permissions[RBAC_TYPE_SERVICES_SERVICE_REQUEST] ===
                                    RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                                    <Button
                                      aria-controls='simple-menu'
                                      aria-haspopup='true'
                                      onClick={(e) => {
                                        handleCellMenuClick(e, item);
                                      }}
                                      className='showpopupInner'
                                    >
                                      <MoreHoriz className='showpopupInner' />
                                    </Button>
                                  )}
                                  <Menu
                                    id={i}
                                    MenuListProps={{ autoFocusItem: false }}
                                    keepMounted
                                    disableRestoreFocus
                                    anchorEl={selectedValue?.anchorEl}
                                    open={
                                      Boolean(selectedValue.anchorEl) &&
                                      selectedValue.id === item.id
                                    }
                                    onClose={handleClose}
                                    className='shadow'
                                  >
                                    <MenuItem
                                      className='pe-4'
                                      onClick={() => {
                                        handleActivate();
                                      }}
                                    >
                                      {selectedValue.isActive ? (
                                        <>
                                          <RemoveCircleIcon className='me-2 action-menu-icon' />
                                          Deactivate
                                        </>
                                      ) : (
                                        <>
                                          <AddCircle className='me-2 action-menu-icon' />
                                          Activate
                                        </>
                                      )}
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onOpenDrawer(e, HOUSEKEEPING_EDIT);
                                      }}
                                    >
                                      <CreateIcon className='me-2 action-menu-icon' />
                                      Edit
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onViewDetailsIcon(e);
                                      }}
                                    >
                                      <RemoveRedEyeIcon className='me-2 action-menu-icon' />
                                      View
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        handleDeletePopupOpen();
                                      }}
                                    >
                                      <DeleteForeverIcon className='me-2 action-menu-icon' />
                                      Delete
                                    </MenuItem>
                                  </Menu>
                                </TableCell>
                              </TableRow>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </TableBody>
                    )}
                  </Droppable>
                </DragDropContext>
                <TableFooter>
                  <TableRow className='paginator'>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                      count={houseKeepingList.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )
        )}{' '}
        {showMultipleDeleteConfirmation && (
          <MultipleDeleteConfirmationPopup
            title={`Are you sure you want to ${actionName} this selection?`}
            subTitle={`A selection of ${selectedHKLength} ${
              selectedHKLength > 1 ? 'houseKeepings' : 'houseKeeping'
            } will be ${actionName}d. This Action is irreversible.`}
            isOpen={showMultipleDeleteConfirmation}
            onClose={() => setShowMultipleDeleteConfirmation(false)}
            onConfirm={() => {
              deleteMultipleSelection();
            }}
            leftButtonName={'Cancel'}
            rightButtonName={'Delete'}
          />
        )}
        {showBulkActiveDeactiveConfirmation && (
          <MultipleDeleteConfirmationPopup
            title={`Are you sure you want to ${actionName} this selection?`}
            subTitle={`A selection of ${selectedHKLength}  ${
              selectedHKLength > 1 ? 'houseKeepings' : 'houseKeeping'
            } will be ${actionName}d.`}
            isOpen={showBulkActiveDeactiveConfirmation}
            onClose={() => setShowBulkActiveDeactiveConfirmation(false)}
            onConfirm={() => {
              handleMultipleStatusChange();
            }}
            leftButtonName={'No'}
            rightButtonName={'Yes'}
          />
        )}{' '}
        {showBulkSearchAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkSearchAlert}
            message="If you perform a search after making selections, the items you've selected will be lost."
            leftButtonName='Cancel'
            rightButtonName='Continue'
            onClose={() => setShowBulkSearchAlert(false)}
            onConfirm={handleContinue}
          />
        )}
        {showBulkKebabSelectionAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkKebabSelectionAlert}
            onClose={() => setShowBulkKebabSelectionAlert(false)}
            message='Please select one item from the list that you want to edit.'
            centerButtonName='OK'
          />
        )}
      </div>
    </div>
  );
};

export default HouseKeepingList;
